export default __webpack_public_path__ + "static/media/single-project-page-01-img18.0ff892e7.jpg";